export default {
  title01: "Поточна погода",
  title02: "24 години",
  title03: "Подивитися прогноз погоди на наступні 10 днів",
  title04: "Інформація про якість повітря (AQI)",
  title05: "Подивитися всю інформацію",
  title06: "Схід та захід сонця",
  title07: "Фаза місяця",
  title08: "Наступий повний місяць",
  title09: "Наступний молодий місяць",
  title10: "День",
  title11: "Ніч",
  title12: "Світанок",
  title13: "Захід сонця",
  title14: "Схід місяця",
  title15: "Захід місяця",
  title16: "Джерело",
  title17: "Початок",
  title18: "Кінець",
  title19: "Використовувати поточну локацію",
  title20: "Шукати місто",
  title21: "Відчуваеться як",
  title22: "Відчуваеться як (у затінку)",
  title23: "Зараз",
  title24: "Сьогодні",
  title25: "Нд",
  title26: "Пн",
  title27: "Вт",
  title28: "Ср",
  title29: "Чт",
  title30: "Пт",
  title31: "Сб",
  title32: "Завантаження",
  title33: "Зараз",
  title34: "Погодинно",
  title35: "По дням",
  title36: "Сонце і Місяць",
  title37: "Якість повітря",
  title38: "Зв'язатися за : xlf550402@gmail.com",
  title39: "Угода про конфіденційність",
  title40: "Авторське право © comfortweather.com 2020 - 2026. Всі права зарезервовані.",
  title41: "Інформація надана [LOGO]",
  title42: "Високо",
  title43: "Низько",
  title44: "Прийняти",
  title45:
    "Дякуємо Вам за використання ComfortWeather! Для покращення захисту ваших законних прав та інтересів, уважно прочитайте ",
  title46: "Політику конфіденційності",
  title47: " перед використанням.",
  title48: "",
  title49: "Зв'язатися за : xyjph123@gmail.com",
  title50: "Авторське право © 24hweather.com 2020 - 2026. Всі права зарезервовані.",
  title51:
    "Дякуємо Вам за використання 24hweather! Для покращення захисту ваших законних прав та інтересів, уважно прочитайте ",
  title52: "Ваше місцезнаходження змінилося. Ви хочете його оновити?",
  title53: "Підтвердити",
  title54: "Скасувати",
  title55: "Назад",
  title56: "Новини",
  title57: "Оновлення погоди...",
  title58: "Погода оновлена",
  title59: "Переглянути все",
  title60: "Авторське право © mobi321.com 2020 - 2026. Всі права зарезервовані.",
  title61: "Вчора",
  title62: "Завтра",
  title63: "Подивитися прогноз погоди на наступні 15 днів",
  title64: "Деталі на сьогодні",
  title65: "Rahu Kaal",
  title66: "Індекси способу життя",
  title67: "Індекси способу життя",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Важко висушити",
  title103: "Повільне сушіння",
  title104: "Добре висихає",
  title105: "Швидке сушіння",
  title106: "Дуже швидке сушіння",

  title107: "Непридатно",
  title108: "Посередні враження",
  title109: "Добре для водних розваг",
  title110: "Дуже придатно",
  title111: "Ідеальні умови",

  title112: "Сприятливі для здоров’я умови",
  title113: "Нейтральні умови",
  title114: "Трохи підвищений ризик",
  title115: "Високий ризик",
  title116: "Дуже високий ризик",

  title117: "Непридатно",
  title118: "Частково придатно",
  title119: "Добре для занять на відкритому повітрі",
  title120: "Дуже придатно",
  title121: "Чудові умови",

  title122: "Дуже сухі умови",
  title123: "Ймовірна сухість",
  title124: "Незначна сухість",
  title125: "Малоймовірна сухість",
  title126: "Дуже малоймовірна сухість",

  title127: "Не рекомендується",
  title128: "Прийнятні умови",
  title129: "Вдалий день",
  title130: "Дуже добрі умови",
  title131: "Ідеальні умови",
};
